import React, { memo, useContext } from 'react';
import { Panel } from '@xyflow/react';
import { CapChartMap } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartMap';
import { ReactFlowControls } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/ReactFlowControls.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { CapChartEmptyState } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartEmptyState.tsx';
import { CapChartPageContext } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChartPage.tsx';

interface Props {
	hasElements: boolean;
	onSave: () => void;
	onReset: () => void;
}

export const CapChartContent = memo(({ hasElements, onSave, onReset }: Props) => {
	const capChartContext = useContext(CapChartPageContext);
	const { downloadLoading } = capChartContext.capChartData;

	return hasElements ? (
		<>
			<Panel position="top-left">
				<CapChartMap />
			</Panel>
			<ReactFlowControls onSave={onSave} onReset={onReset} position="top-right" />
			{downloadLoading && <InlineLoader />}
		</>
	) : (
		<CapChartEmptyState />
	);
});
